import {
  CommissionMutationInput,
  useCreateCommission,
} from 'api-hooks/commission';
import { NavigationRoutes } from 'common/constants';
import notification from 'components/common/notification';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';
import React from 'react';
import { NavigationProps } from 'types';

import CommissionForm from './components/form';
import { CommissionMethodType } from './components/form-type';

export type CommissionCreateParams = null;

export default function CommissionCreate(
  props: NavigationProps<NavigationRoutes.CommissionCreate>,
) {
  const { mutateAsync } = useCreateCommission();

  const { navigate } = useNavigation();
  const permission = useGetCrudPermission('commission-masters');
  const onSubmit = React.useCallback(
    async (values: CommissionMutationInput, form: CommissionMethodType) => {
      const result = await mutateAsync(values);
      const id = result.data.id;

      if (permission.view) {
        navigate(NavigationRoutes.CommissionView, {
          id,
        });
      }
      notification.success({
        message: result.message,
      });
      return result.data;
    },
    [mutateAsync, navigate, permission.view],
  );

  return <CommissionForm {...props} onSubmit={onSubmit} />;
}
